(() => {
  const root = document.querySelector('[data-gv-popup]');
  if (!root) return;

  const KEY = 'gv_popup_dismissed_until';
  const delay = (Number(root.dataset.gvPopDelay) || 8) * 1000;
  const until = Number(localStorage.getItem(KEY) || 0);
  if (Date.now() < until && !root.querySelector('[data-gv-pop-success]')) return;

  const open = () => {
    root.hidden = false;
    document.body.classList.add('gv-pop-open');
  };

  const close = () => {
    root.hidden = true;
    document.body.classList.remove('gv-pop-open');
    localStorage.setItem(KEY, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
  };

  if (root.querySelector('[data-gv-pop-success]')) {
    open();
    localStorage.setItem(KEY, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
  } else {
    setTimeout(open, delay);
  }

  root.querySelectorAll('[data-gv-pop-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !root.hidden) close();
  });
})();
